// Phase N1A — Pure decision helper for AuthContext.checkAuth's error
// branch. Extracted from AuthContext so we can unit-test it without
// rendering the full React tree (Jest does not resolve the `@/` alias
// out of the box; isolating the logic also makes the intent explicit).
//
// Inputs:
//   err    — the error thrown by axios. May have err.response.status
//            (real HTTP error) or no response at all (network /
//            timeout / CORS preflight failure).
//
// Output: one of
//   { action: "clear_session" }   — the token is dead (401 from the
//                                    backend). Caller must wipe
//                                    sdrive_token + sdrive_user.
//   { action: "preserve_session" } — error is transient (network,
//                                    timeout, 5xx, anything that is
//                                    NOT a deliberate rejection from
//                                    the auth layer). Caller must
//                                    keep credentials intact and may
//                                    optionally restore the cached
//                                    user snapshot so the UI doesn't
//                                    flip to "logged out".
//
// Rationale: wiping credentials on every error caused users to be
// kicked to /login whenever the backend was momentarily unreachable
// (deploy, network blip, iOS screen-lock). On the next login attempt
// the user could be tempted to type the wrong password (memory lapse)
// → "Invalid credentials" panic, even though their account was fine.
export function decideAuthFailure(err) {
  const status = err && err.response && err.response.status;
  if (status === 401) return { action: "clear_session" };
  return { action: "preserve_session" };
}
